<div class="main-container">
    <app-loader [isLoading]="loading"></app-loader>
    <div class="inquiry-container">
        <div>
            <app-customer-boooking-header [data]="headerData"></app-customer-boooking-header>
        </div>
        <div class="wbg">
            <div *ngIf="!isMobileView" class="row">
                <label [hidden]="true">{{isValidData()}}</label>
                <div class="col-8">

                    <div *ngIf="category?.length || isMemberVisible" class="row m-0 mt-3 ml-2">
                        <label *ngIf="category?.length && isMemberVisible" class="header-label">Select category and {{categoryLabelName}}</label>
                        <label *ngIf="!category?.length && isMemberVisible" class="header-label">Select {{categoryLabelName}}</label>
                        <label *ngIf="category?.length && !isMemberVisible" class="header-label">Select category</label>
                    </div>
                    <!-- <label class="header-label" *ngIf="category?.length">Select personnel, date and time</label> -->
                    <div *ngIf="category?.length || isMemberVisible" class="row m-0 mt-3">
                        <select *ngIf="category.length" class="min-w ml-2 form-control" [(ngModel)]="selectedCategory"
                            [ngClass]="{'red-error-class' : isSubmitted && !selectedCategory}"
                            (ngModelChange)="onChangeCategory($event)">
                            <option [value]="null" selected disabled>Select Category</option>
                            <option *ngFor="let cat of category" [value]="cat.category_id">
                                {{ cat.category_name }}
                            </option>
                        </select>
                        <select *ngIf="isMemberVisible" class="min-w ml-2 form-control" [(ngModel)]="selectedPerson"
                            [ngClass]="{'red-error-class' : isSubmitted && !selectedPerson}"
                            (ngModelChange)="onChangeMember($event)">
                            <option [value]="null" selected disabled>Select {{categoryLabelName}}</option>
                            <option *ngFor="let member of members" [value]="member.manager_id">
                                {{ member.name }}
                            </option>
                        </select>
                    </div>

                    <div class="row m-0 mt-4">
                        <app-inquiry-form class="w-100" [flexFieldData]="flexFieldData" [isFlexfieldEnable]="isFlexfieldEnable"
                            [showVideoConf]="showVideoConf" [isEmailFieldRequired]="isEmailFieldRequired"
                            [isSubmitted]="isSubmitted">
                        </app-inquiry-form>
                    </div>
                    <div class="row m-0 mt-5 mb-2 jus-c">
                        <button *ngIf="isCancelVisible" class='btn-cancel mr-1' (click)="goBack()">Cancel</button>
                        <button class="btn-nxt ml-1" (click)="goNext()">Enquiry</button>
                    </div>
                </div>
                <div class="col-4">
                    <app-booking-detail class="h-100" [bookingData]="bookingDetails" [flexData]="bookingFlexFieldDetails"
                    [showVideoConf]="showVideoConf" [isMemberVisible]="isMemberVisible" [isCategoryVisible]="isCategoryVisible" [isInquiry]="true"></app-booking-detail>
                </div>
            </div>
            <div *ngIf="isMobileView" class="row">
                <div class="col-12">

                    <div *ngIf="category?.length || isMemberVisible" class="row m-0 mt-3 ml-2">
                        <label *ngIf="category?.length && isMemberVisible" class="header-label">Select category and {{categoryLabelName}}</label>
                        <label *ngIf="!category?.length && isMemberVisible" class="header-label">Select {{categoryLabelName}}</label>
                        <label *ngIf="category?.length && !isMemberVisible" class="header-label">Select category</label>
                    </div>
                    <div *ngIf="category?.length ||isMemberVisible" class="row m-0 mt-1 ml-2">
                        <select *ngIf="category?.length" class="col-5 form-control" [(ngModel)]="selectedCategory"
                            [ngClass]="{'red-error-class' : isSubmitted && !selectedCategory}"
                            (ngModelChange)="onChangeCategory($event)">
                            <option [value]="null" selected disabled>Select Category</option>
                            <option *ngFor="let cat of category" [value]="cat.category_id">
                                {{ cat.category_name }}
                            </option>
                        </select>
                        <div class="col-1"></div>
                        <select *ngIf="isMemberVisible" class="col-5 form-control" [(ngModel)]="selectedPerson"
                            [ngClass]="{'red-error-class' : isSubmitted && !selectedPerson}"
                            (ngModelChange)="onChangeMember($event)">
                            <option [value]="null" selected disabled>Select {{categoryLabelName}}</option>
                            <option *ngFor="let member of members" [value]="member.manager_id">
                                {{ member.name }}
                            </option>
                        </select>
                    </div>
                    <div class="row m-0 mt-4">
                        <app-inquiry-form class="w-100" [flexFieldData]="flexFieldData" [isFlexfieldEnable]="isFlexfieldEnable"
                            [showVideoConf]="showVideoConf" [isEmailFieldRequired]="isEmailFieldRequired"
                            [isSubmitted]="isSubmitted">
                        </app-inquiry-form>
                    </div>
                    <div class="row m-0 mt-5 mb-2 jus-c">
                        <button *ngIf="isCancelVisible" class='btn-cancel mr-1' (click)="goBack()">Cancel</button>
                        <button class="btn-nxt ml-1" (click)="goNext()">Enquiry</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <app-footer-powered-by-image></app-footer-powered-by-image>
    </div>

</div>
